// extracted by mini-css-extract-plugin
export default {"videoPlayerCard":"VideoCardSlider_videoPlayerCard__bhHPi","playIcon":"VideoCardSlider_playIcon__Ci8Xt","img":"VideoCardSlider_img__1quTI"};